import styled from 'styled-components';
import { Tag } from 'antd';

export const MetaTagsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

export const MetaTagChip = styled(Tag)`
  background-color: #f5f5f5 !important;
  color: rgb(223, 76, 53) !important;
  border: 1px solid rgb(223, 76, 53) !important;
  border-radius: 6px !important;
  padding: 6px 12px !important;
  font-size: 14px !important;
  display: inline-flex !important;
  align-items: center !important;
  margin: 0 !important;
  height: auto !important;
  line-height: 1.5 !important;
  cursor: default !important;
  box-shadow: 0 1px 2px rgb(223, 76, 53, 0.05) !important;
  transition: all 0.2s ease !important;
  
  .anticon-close {
    color: rgb(223, 76, 53) !important;
    margin-left: 8px !important;
    font-size: 12px !important;
    cursor: pointer !important;
    transition: color 0.2s ease !important;
    
    &:hover {
      color: rgb(223, 76, 53) !important;
    }
  }
  
  &:hover {
    border-color: rgb(223, 76, 53) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transform: translateY(-1px);
  }
`;

export const MetaTagText = styled.span`
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

